// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","769":"f9153fb1aa2dc5b25ed981de191890edf55d873c","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"38afaf382e274b3ddc69","731":"f67ff1a6a01f91503c44","769":"bf9298f5c2daff8592a0","843":"a8065020245db9b97c67","883":"e9d84324a2312bc5f9ef"}[chunkId] + ".js";
};